import { OptionSelected, SelectProps } from './Select';
import {  CircularProgress, TextField, Autocomplete, Tooltip, Icon  } from "@mui/material";

interface AsyncProps extends SelectProps {
  autoFocus: boolean;
  loadOptions: (input?: string) => Promise<any>;
  updateParam?:any;
	getDisabled: (event: React.MouseEvent) => Promise<any> | null;
	matchDisabled: boolean | null;
}

interface AsyncState {
  options: OptionSelected[];
  loading: boolean;
  inputValue: string;
  updateParam?:any;
}

export default class Async extends React.PureComponent<AsyncProps, AsyncState> {
  constructor(props: AsyncProps) {
    super(props);

    this.state = {
      options: [],
      inputValue: '',
      loading: false,
      updateParam:'',
    };
  }
	timer:any;

  componentDidMount() {
    this.getOptions('');
  }

  componentDidUpdate(_lastProps: AsyncProps, _lastState: AsyncState) {
    if (this.props?.updateParam !== _lastProps?.updateParam) {
      this.getOptions('');
    }
    const inputVal = this.props?.multi ? "" : (typeof this.state?.inputValue === 'string' && this.state.inputValue.length > 0 ? this.state.inputValue : this.props.value?.label ?? "");

    if (!this.props?.multi && _lastState?.inputValue !== inputVal) {
      this.setState((state) => { return { ...state, inputValue: inputVal } });
    }
  }

  onInputChange = (event: any) => {
    const { value } = event.target as HTMLInputElement;
    if (event.nativeEvent?.type === 'input') {
      this.setState((state) => { return { ...state, inputValue: value ?? "" } });
      clearTimeout(this.timer);
			this.timer = setTimeout(() => {
        this.getOptions(value);
			}, 300);
    }
  };

  handleChange = (event: React.ChangeEvent, value: any, reason: string, option: any) => {
    let { onChange, multi } = this.props;
    if (typeof onChange === 'function') {
      onChange(value);
    }

    //reset Input value on change
    this.setState((state) => {
      return { ...state, loading: false, inputValue: multi ? "" : value?.label }
    });
    this.getOptions();
  };

  getOptions = async (input = '') => {
    const { loadOptions } = this.props;

    this.setState({
      loading: true,
    });

    const options = await loadOptions(input);

    this.setState((state) => ({ ...state, options, loading: false }));
  };

	getDisabledItems = async (event: React.MouseEvent) => {
		const { getDisabled } = this.props;
		await getDisabled(event);
		await this.getOptions(this.state.inputValue);
	}

  filterOptions = (item: OptionSelected) => {
    const { filterOptions } = this.props;

    return filterOptions ? filterOptions(item) : true;
  };

  render() {
    const {
      label,
      disabled,
      onChange,
      value,
      multi,
      placeholder,
      className,
      mandatory,
      getOptionLabel,
      error,
      filterOptions,
			matchDisabled,
      creatable,
      id,
      renderTags,
      getOptionDisabled,
      renderOption,
      important,
      helperText,
      filterSelectedOptions,
      getOptionSelected
    } = this.props;

		const finalValue = multi
			? Array.isArray(value) ? value : []
			: (value && !Array.isArray(value) ? value : null);

    return (
      <Autocomplete
        id={id}
        disabled={disabled}
        className={className}
        filterOptions={filterOptions}
        filterSelectedOptions={filterSelectedOptions ?? true}
        loading={this.state.loading}
        multiple={multi}
        onChange={this.handleChange}
        options={this.state.options}
				isOptionEqualToValue={getOptionSelected ?? ((option: OptionSelected, value: OptionSelected): boolean => option?.value === value?.value)}
        getOptionDisabled={getOptionDisabled}
        getOptionLabel={getOptionLabel ?? ((option: any): string => option?.label || '')}
        disableClearable={mandatory}
        renderTags={renderTags}
        ChipProps={{size: 'small',}}
        // inputValue={this.state.inputValue}
        // onInputChange={this.onInputChange} https://github.com/mui/material-ui/blob/v4.x/packages/material-ui-lab/src/useAutocomplete/useAutocomplete.js#L152
        renderInput={(params: any) => (
          <TextField
            {...params}
            label={label}
            placeholder={
              placeholder ||
              ((multi && finalValue?.length === 0) || (!multi && !finalValue)
                ? `${window.Alfresco.messages.global['button.select']}...`
                : '')
            }
            variant={'outlined'}
            required={mandatory}
            error={!!error}
            helperText={error || important || helperText}
            onChange={this.onInputChange}
            //inputProps={{ ...params.inputProps, value: (!this.props?.multi ? (typeof this.state?.inputValue === 'string' && this.state.inputValue.length > 0 ? this.state.inputValue : this.props.value?.label ?? "") : (this.state?.inputValue ?? "")) }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <div className={"asyncEndAdornment"}>
                  {this.state.loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
									{!disabled && !(matchDisabled === null || matchDisabled === undefined) && (
										<React.Fragment>
											{!matchDisabled && (
												<Tooltip title={window.Alfresco.messages.global['edocat.codebook-inactive']} placement="top">
                                                  <Icon
                                                      className={`fas fa-list-alt`}
                                                      onClick={this.props.disabled ? null : this.getDisabledItems}
                                                      fontSize={"small"}
                                                  />
												</Tooltip>
											)}
											{matchDisabled && (
												<Tooltip title={window.Alfresco.messages.global['edocat.codebook-active']}>
                                                    <Icon
                                                        className={`far fa-list-alt`}
                                                        onClick={this.props.disabled ? null : this.getDisabledItems}
                                                        fontSize={"small"}
                                                    />
												</Tooltip>
											)}
										</React.Fragment>
									)}
                </div>
              ),
            }}
            InputLabelProps={{ shrink: true }}
          />
        )}
        value={finalValue}
        freeSolo={creatable}
        renderOption={renderOption}
      />
    );
  }
}
